<template>
  <div>Fiók törlése</div>
</template>

<script>
import config from '@/config'
import utils from '@/utils'
import notify from '@/notify'

export default {
  created: function () {
    let query = this.$route.query
    // eslint-disable-next-line no-prototype-builtins
    if (query.hasOwnProperty('t')) {
      let token = query.t

      this.$http({
        url: config.SERVER_DOMAIN + '/api/guest/emailcancellation',
        method: 'DELETE',
        params: { ...this.$store.getters.getAuthParams, cancelToken: token },
      }).then(response => {
        console.log('--- email confirmation success')
        // eslint-disable-next-line
        notify.success(response.body.msg)
      }, error => {
        utils.httpError(error)
      }).finally(() => {
        this.$router.push('Reservation')
      })
    } else {
      notify.warning('Hibás fiók törlési link!')
      this.$router.push('Reservation')
    }
    console.log(query)
    console.log('$$$$$$$$$$$')
    console.log(query.t)
  },
}
</script>

<style scoped>

</style>
